// extracted by mini-css-extract-plugin
export default {"base":"TitleMinor_base__i70ED"};